
import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

export default function CompanyStory() {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  return (
    <section
      ref={ref}
      className="relative py-20 sm:py-32 bg-[#050505] overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.03]">
        <div
          className="w-full h-full"
          style={{
            backgroundImage:
              'linear-gradient(#00E5FF 1px, transparent 1px), linear-gradient(90deg, #00E5FF 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image column */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <div className="relative">
              <div className="relative overflow-hidden">
                <img
                  src="https://eurekasanok.pl/wp-content/uploads/2018/11/spawanie.png"
                  alt="EUREKA - Spawalnictwo przemysłowe"
                  className="w-full h-[400px] sm:h-[500px] object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
              </div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 sm:w-40 sm:h-40 border border-[#00E5FF]/20 hidden lg:block" />
              <div className="absolute -top-4 -left-4 w-24 h-24 sm:w-32 sm:h-32 border border-[#00E5FF]/10 hidden lg:block" />
            </div>
          </motion.div>

          {/* Text column */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <span
              className="text-[#00E5FF] text-xs tracking-[0.3em] uppercase font-semibold"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              Nasza Historia
            </span>
            <div className="h-[2px] w-16 bg-[#00E5FF] mt-3" />

            <h2
              className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-6 mb-8 leading-tight"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
            >
              Od Handlu do
              <br />
              <span className="text-[#00E5FF]">Przemysłu Stalowego</span>
            </h2>

            <div
              className="space-y-5 text-[#C0C7CF] text-sm sm:text-base leading-relaxed"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              <p>
                Firma P.W. <strong className="text-white">EUREKA</strong> została założona w grudniu
                1989 roku. W pierwszym okresie działalności firma zajmowała się handlem. Od 1991 roku
                rozpoczęła działalność w zakresie usług antykorozyjnych wysokościowych.
              </p>
              <p>
                Wykonywała usługi konserwacji słupów wysokiego napięcia, suwnic i chłodni kominowych
                w rejonie województwa śląskiego. Od 1996 roku firma przeniosła swoją działalność na
                teren województwa podkarpackiego, zmieniając profil na usługi w zakresie{' '}
                <strong className="text-[#00E5FF]">
                  wykonawstwa konstrukcji stalowych
                </strong>
                .
              </p>
              <p>
                W latach 1996-98 firma eksportowała do Wielkiej Brytanii konstrukcje stalowo-żeliwne
                oranżerii w stylu wiktoriańskim, zdobywając doświadczenie na rynkach międzynarodowych.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#00E5FF]/10 border border-[#00E5FF]/30">
                  <i className="ri-map-pin-line text-lg text-[#00E5FF]" />
                </div>
                <div>
                  <div
                    className="text-white text-sm font-semibold"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    Sanok
                  </div>
                  <div
                    className="text-[#666] text-xs"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    Podkarpackie
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#00E5FF]/10 border border-[#00E5FF]/30">
                  <i className="ri-calendar-line text-lg text-[#00E5FF]" />
                </div>
                <div>
                  <div
                    className="text-white text-sm font-semibold"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    Od 1989
                  </div>
                  <div
                    className="text-[#666] text-xs"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    Na rynku
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
